export default __webpack_public_path__ + "static/media/chat-dots.50eea055.svg";